import TrackingAPI from "api/TrackingAPI";
import MaskGradientIcon from 'assets/mask_gradient_icon.svg?react';
import NiceModal from "components/modals/NiceModal";
import useEnterKey from 'hooks/useKeydown';
import { useDispatch } from 'redux-react-hook';
import { usePurchaseMediaPackMutation } from 'services/api/mediaPacksApi';
import { refetchCurrentUser } from "store/DEPRECATEDusers/asyncAction";
import styled from "styled-components";
import { errorAlert, successAlert } from 'ui-kit/Alert';
import { getErrorMessage } from "utils/error";

interface IConfirmTokenMediaPackModalProps {
  isVisible: boolean;
  onClose: () => void;
  mediaPackId: string;
  analyticsData?: {
    config: Record<string, unknown>;
    scenarioId: string;
    characterName: string;
    mediaPackId: string;
  };
}

const ConfirmTokenMediaPackModal = (props: IConfirmTokenMediaPackModalProps) => {
  const { isVisible, onClose, mediaPackId, analyticsData } = props;
  const [purchaseMediaPack, { isLoading }] = usePurchaseMediaPackMutation();
  const dispatch = useDispatch();


  const handleBuyMediaPack = async () => {
    try {
      await purchaseMediaPack({ id: mediaPackId }).unwrap();
      TrackingAPI.trackEvent('media_pack_purchase_confirm', analyticsData);
      dispatch(refetchCurrentUser());
      onClose();
      successAlert('Media pack purchased successfully');
      window.location.reload();
    } catch (error) {
      errorAlert(getErrorMessage(error));
    }
  };

  useEnterKey('Enter', handleBuyMediaPack);

  return (
    <NiceModal isVisible={isVisible} onClose={onClose}>
      <Root>
        <MaskGradientIcon />
        <Title>Ready to Go?</Title>
        <Subtitle>You’re about to unlock this pack using your tokens.</Subtitle>
        <Wrapper>
          <OrangeOutlineButton onClick={onClose}>
            Cancel
          </OrangeOutlineButton>
          <Button
            disabled={isLoading}
            onClick={handleBuyMediaPack}
          >
            Confirm
          </Button>
        </Wrapper>
      </Root>
    </NiceModal>
  );
};

export default ConfirmTokenMediaPackModal;

const Root = styled.div`
  width: 380px;
  padding: 24px;
  box-sizing: border-box;
  font-family: "Nunito Sans";
  font-optical-sizing: auto;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 410px) {
    width: unset;
  }

  svg {
    width: 48px;
    height: 48px;
  }
`;

const Wrapper = styled.div`
  font-family: 'Unbounded', sans-serif;
  font-optical-sizing: auto;
  width: 100%;
  display: flex;
  gap: 16px;
`;

const Title = styled.div`
  text-align: center;
  margin: 24px 0;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;

const Subtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: white;
  text-align: center;
  margin-bottom: 32px;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`;

const OrangeOutlineButton = styled.div`
  cursor: pointer;
  color: rgba(255, 126, 85, 1);
  border: 1px solid rgba(255, 126, 85, 1);
  font-size: 16px;
  line-height: 24px;
  height: 48px;
  padding: 0 32px;
  border-radius: 1000px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex: 1;

  :hover {
    background: rgba(255, 126, 85, 1);
    color: white;
  }
`;

const Button = styled.div<{ disabled?: boolean }>`
  background: #ff7e55;
  border-radius: 1000px;
  color: white;
  font-weight: bold;
  padding: 0 32px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  font-family: Nunito Sans;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;
  flex: 1;

  :hover {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 0.8)};
  }
`;


